const MegaphoneIcon = ({ size = 57, className = '' }) => {
    return (
        <svg 
            width={size} 
            height={size * (56/57)} 
            viewBox="0 0 57 56" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path d="M8.66667 32.0844H25L34.5278 40.2511V10.3066L25 18.4733H8.66667V32.0844Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14.1115 44.5284V32.084H19.5559V44.5284C19.5559 45.1728 19.0336 45.6951 18.3893 45.6951H15.2782C14.6338 45.6951 14.1115 45.1728 14.1115 44.5284Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M34.5278 32.2771C35.4215 32.2771 36.3065 32.1011 37.1321 31.7591C37.9578 31.4171 38.7081 30.9158 39.34 30.2838C39.972 29.6519 40.4733 28.9016 40.8153 28.0759C41.1573 27.2503 41.3333 26.3653 41.3333 25.4716C41.3333 24.5779 41.1573 23.6929 40.8153 22.8672C40.4733 22.0415 39.972 21.2913 39.34 20.6593C38.7081 20.0274 37.9578 19.5261 37.1321 19.1841C36.3065 18.842 35.4215 18.666 34.5278 18.666L34.5278 25.4716L34.5278 32.2771Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M46 25.666H49.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M41.846 14L44.3209 11.5251" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M41.846 35L44.3209 37.4749" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default MegaphoneIcon